import Vue from 'vue'
import Component from 'vue-class-component'
@Component
export default class UnitConverter extends Vue {
    get currentSystem () {
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }
}